import { render, staticRenderFns } from "./BookingSummary.vue?vue&type=template&id=ede41142"
import script from "./booking-summary.js?vue&type=script&lang=js&external"
export * from "./booking-summary.js?vue&type=script&lang=js&external"
import style0 from "./booking-summary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports